import { render, staticRenderFns } from "./ManageDelivery.vue?vue&type=template&id=088f8abd&scoped=true&"
import script from "./ManageDelivery.vue?vue&type=script&lang=js&"
export * from "./ManageDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ManageDelivery.vue?vue&type=style&index=0&id=088f8abd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f8abd",
  null
  
)

export default component.exports